<template>
    <div class="advanced_screening">
        <b-modal ref="modal" id="advanced_screening_modal" hide-footer centered :title="modalTitle">
            <form @submit.stop.prevent="handleSubmit">
                <!-- 阻擋頁面刷新，執行你的function -->
                <h3>
                    選擇品牌
                </h3>
                <div class="brand">
                    <div class="row">
                        <div class="col-12 col-sm-3" v-for="(company, index) in companies" v-bind:key="index">
                            <input v-model="selectedCompanyId" :id="brandPrefix + '_' + (index + 1)" type="radio" :name="brandPrefix" :value="company.company_id">
                            <label :for="brandPrefix + '_' + (index + 1)" class="hoverDark">
                                <template v-if="(index + 1) == 3">
                                    {{ company.name }}
                                </template>
                            </label>
                        </div>
                    </div>
                </div>
                <h3>
                    選擇區域
                </h3>
                <div class="county">
                    <div class="row">
                        <div class="col-6 col-sm-4">
                            <input v-model="selectedAreaId" :id="radioname + '_'" type="radio" :name="radioname" value="">
                            <label :for="radioname + '_'" class="posr">所有區域</label>
                        </div>
                        <div class="col-6 col-sm-4" v-for="(area, index) in areas" v-bind:key="index">
                            <input v-model="selectedAreaId" :id="radioname + '_' + index" type="radio" :name="radioname" :value="area.AreaID">
                            <label :for="radioname + '_' + index" class="posr">{{ area.AreaName }}</label>
                        </div>
                    </div>
                </div>
                <div slot="modal-footer" class="modal_footer">
                    <div class="row justify-content-between">
                        <div class="col-6">
                            <b-btn type="reset" @click="handleClose()" class="hoverFill">
                                取消
                            </b-btn>
                        </div>
                        <div class="col-6 text-right">
                            <b-btn type="submit" class="hoverFill">
                                送出
                            </b-btn>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import classApi from '@/api/class'
    import _ from 'lodash'
    import { mapGetters, mapMutations } from 'vuex';

    export default {
        // name:'FilterModal',
        data() {
            return {
                modalTitle: '進階搜尋',
                radioname: "county",
                brandPrefix: "brand",
                companies: [{
                        company_id: 'A0',
                        name: '特力屋',
                    },
                    {
                        company_id: 'B0',
                        name: 'HOLA',
                    },
                    {
                        company_id: '',
                        name: '所有品牌',
                    },
                ],
                areas: [],
                selectedCompanyId: null,
                selectedAreaId: null,
            }
        },
        computed: {
            ...mapGetters('advancedSearch', [
                'companyId',
                'areaId',
            ]),
        },
        created() {
            this.getAdvancedSearch();
            this.selectedCompanyId = this.companyId;
        },
        watch: {
            companyId(val) {
                this.selectedCompanyId = val;
            },
        },
        methods: {
            ...mapMutations('advancedSearch', [
                'setCompanyId',
                'setAreaId',
            ]),
            getAdvancedSearch() {
                classApi.advancedSearch((data) => {
                    this.areas = _.get(data, 'Area', []);
                })
            },
            handleSubmit() {
                this.setCompanyId(this.selectedCompanyId);
                this.setAreaId(this.selectedAreaId);
                this.$refs.modal.hide() 
            },
            handleClose() {
                this.selectedCompanyId = this.companyId;
                this.selectedAreaId = this.areaId;
                this.$refs.modal.hide()
            },
        },
    }
</script>